import { CompraContext } from "../../../context/CompraContext";
import { EmailContext } from "../../../context/EmailContext";
import Loading from "../../../components/Loading/Loading";
import { useContext, useEffect, useState } from "react";
import "../newStyle.css";

import ObjectList from "../../../components/ObjectList";

import banner_mulher_sorrindo from "../../../images/Certificado/banner_mulher_sorrindo.avif";
import certificadoescudo from "../../../images/Certificado/certificadoescudo.webp";
import icone_suporte from "../../../images/Certificado/icone_suporte.avif";
import icone_online from "../../../images/Certificado/icone_online.avif";
import icone_bandeira_brasil from "../../../images/Certificado/icone_bandeira_brasil.avif";
import homem_duvida from "../../../images/Certificado/homem_duvida.webp";
import mulher_assustada from "../../../images/Certificado/mulher_assustada.webp";
import homem_cocando_cabeca from "../../../images/Certificado/homem_cocando_cabeca.webp";
import icone_emoji_feliz from "../../../images/Certificado/icone_emoji.svg";
import icone_relogio from "../../../images/Certificado/icone_relogio.svg";
import icone_carteira from "../../../images/Certificado/icone_carteira.svg";
import icone_diamante from "../../../images/Certificado/icone_diamante.svg";
import icone_estrela from "../../../images/Certificado/icone_estrela.svg";
import icone_sinal_positivo from "../../../images/Certificado/icone_positivo.svg";
import logo_exactus_cinza from "../../../images/Certificado/logo_exactus_cinza.svg";
import Footer from "../../../components/Footer/Footer";

function CertificadoHome() {
  const { ObterProdutos, Produto, setLoading, loading, setCadastro, Revenda } =
    useContext(CompraContext);
  const { setContabilidade, setPdf } = useContext(EmailContext);
  const [activeIndex, setActiveIndex] = useState(null);

  const [hoveredIndexPassoCompra, setHoveredIndexPassoCompra] = useState(null);

  const [currentIndexImage, setCurrentIndexImage] = useState(0);
  const imageItems = [
    {
      key: 1,
      image: homem_duvida,
      width: 325,
      height: 395,
    },
    {
      key: 2,
      image: mulher_assustada,
      width: 325,
      height: 395,
    },
    {
      key: 3,
      image: homem_cocando_cabeca,
      width: 325,
      height: 395,
    },
  ];
  const currentItem = imageItems[currentIndexImage];

  const passosComoComprar = [
    {
      numero: "01",
      titulo: "Escolha",
      texto: (
        <>
          Selecione o tipo ideal para sua necessidade:{" "}
          <b>e-CPF, e-CNPJ em arquivo, cartão ou em nuvem.</b>
        </>
      ),
    },
    {
      numero: "02",
      titulo: "Compre",
      texto: (
        <>
          <b>Finalize o pagamento com seu cartão de crédito ou pix </b> em
          poucos cliques, com total proteção dos seus dados.
        </>
      ),
    },
    {
      numero: "03",
      titulo: "Valide",
      texto: (
        <>
          Use sua CNH para validar sua identidade por videoconferência.{" "}
          <b>O processo é simples e 100% online</b>. Importante:{" "}
          <b>A validação acontece somente com o documento da CNH.</b>
        </>
      ),
    },
    {
      numero: "04",
      titulo: "Receba",
      texto: (
        <>
          Em 10 minutos, em média,{" "}
          <b>o seu certificado é emitido e já pode ser usado na hora.</b>
        </>
      ),
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndexImage((prevIndex) => (prevIndex + 1) % imageItems.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [imageItems.length]);

  const goToSlide = (index) => {
    setCurrentIndexImage(index);
  };

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      pergunta: "O que é um certificado digital?",
      resposta:
        "É sua identidade eletrônica para assinar documentos e acessar sistemas oficiais com validade jurídica.",
    },
    {
      pergunta: "Qual a diferença do e-CPF e o e-CNPJ?",
      resposta:
        "O e-CPF é usado por pessoas físicas; o e-CNPJ é para empresas que precisam emitir notas fiscais e cumprir obrigações fiscais.",
    },
    {
      pergunta: "É obrigatório ter CNH válida para comprar o e-CPF ou e-CNPJ?",
      resposta:
        "Sim. Para validação online, a CNH é o único documento aceito. Outras formas exigem atendimento presencial.",
    },
    {
      pergunta:
        "O que eu faço se não conseguir instalar o certificado digital?",
      resposta:
        "Conte com nosso suporte técnico. A equipe da Exactus orienta cada passo até tudo funcionar perfeitamente.",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    setPdf("");
    setCadastro("");
    ObterProdutos()
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {loading && <Loading />}
      <main className="main-content">
        <section className="certificado-header">
          <article className="certificado-oferta">
            <h1 className="certificado-oferta-titulo">
              Certificado Digital a partir
              <span className="certificado-texto-destaque"> de R$79,00.</span>
            </h1>
            <p className="certificado-oferta-horario">
              Horário de emissão do seu certificado: das 08:00 as 17:00. De
              segunda à sexta.
            </p>
            <h2 className="certificado-oferta-subtitulo">
              Certificado pronto em{" "}
              <span className="certificado-texto-destaque">10 minutos!</span>
            </h2>
          </article>
          <figure className="certificado-imagem">
            <img
              src={banner_mulher_sorrindo}
              alt="Mulher sorrindo fazendo sinal positivo com as mãos"
              width={310}
              height={470}
            />
          </figure>
          <article className="certificado-beneficios">
            <h2 className="certificado-beneficios-titulo">
              Processo simplificado e{" "}
              <span className="certificado-texto-destaque">
                sem complicação.
              </span>
            </h2>
            <div className="certificado-beneficios-lista">
              <article className="certificado-beneficio-item">
                <img
                  src={icone_bandeira_brasil}
                  alt="Ícone bandeira do Brasil"
                  width={38}
                  height={38}
                />
                <p>Validade Jurídica em todo o Brasil</p>
              </article>
              <article className="certificado-beneficio-item">
                <img
                  src={icone_online}
                  alt="Ícone 100% online"
                  width={38}
                  height={38}
                />
                <p>100% Online</p>
              </article>
              <article className="certificado-beneficio-item">
                <img
                  src={icone_suporte}
                  alt="Ícone suporte"
                  width={38}
                  height={38}
                />
                <p>Suporte com gente de verdade!</p>
              </article>
            </div>
          </article>
        </section>

        <section id="certificado-cards" className="certificado-cards">
          <article className="certificado-cards-titulo">
            <h2 className="certificado-cards-titulo-principal">
              Escolha seu{" "}
              <span className="certificado-texto-destaque">
                certificado digital aqui!
              </span>
            </h2>
          </article>
          {Produto && <ObjectList Produto={Produto} Revenda={Revenda} />}
        </section>

        <section className="certificado-dificuldades">
          <article className="certificado-carrousel">
            <div id={currentItem.key} className="carousel-container">
              <figure className="carousel-image-wrapper">
                <img
                  src={currentItem.image}
                  alt="Imagem de pessoa com dúvida"
                  width={currentItem.width}
                  height={currentItem.height}
                  loading="lazy"
                />
              </figure>
            </div>

            <div className="certificado-carousel-indicators">
              {imageItems.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`carousel-indicator ${
                    index === currentIndexImage ? "active" : ""
                  }`}
                  aria-label={`Ir para slide ${index + 1}`}
                />
              ))}
            </div>
          </article>
          <article>
            <h3 className="certificado-dificuldade-titulo">
              Nós sabemos que nem sempre é fácil{" "}
              <span className="certificado-texto-destaque">
                adquirir um certificado digital.
              </span>
            </h3>
            <p className="certificado-dificuldade-subtitulo">
              <strong>Você não está sozinho nessa. </strong> A gente sabe que
              lidar com burocracia pode ser frustrante. Por isso,{" "}
              <strong>
                estamos aqui pra facilitar tudo e te ajudar a resolver isso de
                forma rápida,
              </strong>{" "}
              clara e sem complicação.
            </p>
          </article>
        </section>

        <section className="certificado-como-comprar">
          <article>
            <h2 className="certificado-como-comprar-titulo">
              Como comprar seu{" "}
              <span className="certificado-texto-destaque">
                certificado digital?
              </span>
            </h2>
          </article>
          <article className="certificado-como-comprar-passo-a-passo">
            {passosComoComprar.map((passo, index) => (
              <div
                key={index}
                className={`certificado-como-comprar-passo-destaque ${
                  hoveredIndexPassoCompra === index ? "active" : ""
                }`}
                onMouseEnter={() => setHoveredIndexPassoCompra(index)}
                onMouseLeave={() => setHoveredIndexPassoCompra(null)}
              >
                <h3>{passo.numero}</h3>

                <article>
                  <div className="passo-header">
                    <h3>{passo.titulo}</h3>
                    <span
                      className={`arrow ${
                        hoveredIndexPassoCompra === index ? "rotate" : ""
                      }`}
                    >
                      ▾
                    </span>
                  </div>
                  <p
                    className={`passo-subtexto ${
                      hoveredIndexPassoCompra === index ? "active" : ""
                    }`}
                  >
                    {passo.texto}
                  </p>
                </article>
              </div>
            ))}
          </article>
        </section>

        <section className="certificado-para-que-serve">
          <figure>
            <img
              src={certificadoescudo}
              alt="Emblema com um cadeado"
              width={250}
              height={324}
              loading="lazy"
            />
          </figure>
          <article>
            <h2>
              Para que serve um{" "}
              <span className="certificado-texto-destaque">
                Certificado Digital?
              </span>
            </h2>
            <p>
              <b>
                Pense no certificado digital como a sua chave mestra no mundo
                online.
              </b>{" "}
              É com ela que você destrava portas importantes: emitir notas,
              assinar contratos, acessar portais do governo.
            </p>
            <p>
              <b>
                Assim como você não entra em casa sem a chave, também não acessa
                muitos direitos e obrigações digitais sem essa identidade
                segura.
              </b>
            </p>
          </article>
        </section>

        <section className="certificado-por-que-adquirir">
          <h2>
            Por que adquirir seu certificado com{" "}
            <span className="certificado-texto-destaque">a Exactus?</span>
          </h2>
          <article>
            <div className="certificado-por-que-adquirir-item">
              <img
                src={icone_relogio}
                alt="ícone relógio"
                width={32}
                loading="lazy"
              />
              <p>Emissão em até 10 minutos</p>
            </div>
            <div className="certificado-por-que-adquirir-item">
              <img
                src={icone_carteira}
                alt="ícone carteira"
                width={32}
                loading="lazy"
              />
              <p>Preço a partir de R$ 79,00</p>
            </div>
            <div className="certificado-por-que-adquirir-item">
              <img
                src={icone_emoji_feliz}
                alt="ícone emoji feliz"
                width={32}
                loading="lazy"
              />
              <p>Atendimento humanizado</p>
            </div>
            <div className="certificado-por-que-adquirir-item">
              <img
                src={icone_sinal_positivo}
                alt="ícone sinal positivo"
                width={32}
                height={28.3}
                loading="lazy"
              />
              <p>Certificado válido em todo o Brasil</p>
            </div>
            <div className="certificado-por-que-adquirir-item">
              <img
                src={icone_estrela}
                alt="ícone estrela"
                width={32}
                height={30.5}
                loading="lazy"
              />
              <p>Milhares de clientes satisfeitos</p>
            </div>
            <div className="certificado-por-que-adquirir-item">
              <img
                src={icone_diamante}
                alt="ícone diamante"
                width={32}
                height={32.8}
                loading="lazy"
              />
              <p>54 anos de tradição no mercado</p>
            </div>
          </article>
        </section>

        <section className="certificado-duvidas">
          <article className="certificado-duvidas-titulo">
            <h2>
              FAQ Dúvidas sobre{" "}
              <span className="certificado-texto-destaque">
                Certificado Digital!
              </span>
            </h2>
            <p>
              Antes de finalizar sua compra, dê uma olhada nas perguntas que
              mais recebemos de quem está exatamente onde você está agora.{" "}
              <b>
                Essas respostas rápidas podem esclarecer o que falta para você
                seguir com tranquilidade e segurança.
              </b>
            </p>
          </article>
          <article className="certificado-duvidas-accordions">
            {faqs.map((faq, index) => (
              <div
                className={`accordion-item ${
                  activeIndex === index ? "active" : ""
                }`}
                key={index}
              >
                <div
                  className={`accordion-header ${
                    activeIndex === index ? "active" : ""
                  }`}
                  onClick={() => toggle(index)}
                >
                  <h3>{faq.pergunta}</h3>
                  <button>{activeIndex === index ? "−" : "+"}</button>
                </div>
                <div className="accordion-content">
                  <p>{faq.resposta}</p>
                </div>
              </div>
            ))}
          </article>
        </section>

        <section className="certificado-chamada-para-acao">
          <h2>
            Não adie o que pode ser{" "}
            <span className="certificado-texto-destaque">
              resolvido em 10 minutos.
            </span>
          </h2>
          <h3>
            Ganhe agilidade, segurança e tranquilidade para o seu negócio.
          </h3>
          <article className="certificado-botoes">
            <button
              className="btn-secundario"
              onClick={() => scrollToSection("certificado-cards")}
            >
              Emitir e-CNPJ Agora
            </button>
            <button
              className="btn-primario"
              onClick={() => scrollToSection("certificado-cards")}
            >
              Emitir e-CPF Agora
            </button>
          </article>
          <div>
            <p>
              <strong>⚠️ Aviso importante:</strong>
            </p>
            <p>
              A emissão online exige uma CNH válida.
              <strong> Outros documentos não são aceitos.</strong>
            </p>
          </div>
        </section>
      </main>
      <Footer footerCertificado={true} />
    </>
  );
}

export default CertificadoHome;
